<template>
  <div class="post-lifts">
    <Article v-for="(item, nr) in itemStore.getItems" :key="item.id" :item="item" :nr="nr"/>
  </div>
</template>


<script lang="ts" setup>
import Article from "@/components/Article.vue";
import {useItemStore} from "@/stores/items";

const itemStore = useItemStore();
</script>
